export default __webpack_public_path__ + "static/media/018-bear.42bec38f.svg";